import gbAntInputEnterSearch from "./src/gb-ant-input-enter-search.vue";
const gbAntInputEnterSearchCompenet = function(Vue) {
  Vue.component(gbAntInputEnterSearch.name, gbAntInputEnterSearch);
};
export default gbAntInputEnterSearchCompenet;
